import { Controller } from "react-hook-form";

import { Modal, Text, Button, EmailField } from "@consumidor-positivo/aurora";

import { hasFieldErrors } from "@libs/acp/steps/utils/hasFieldErrors";

import { Toast } from "@libs/acp/components/Toast";

import { useUpdateEmailModal } from "./hooks";

import "./styles.scss";

type UpdateEmailModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onSuccess: (newEmail: string) => void;
};

export const UpdateEmailModal = ({
	isOpen,
	onClose,
	onSuccess,
}: UpdateEmailModalProps) => {
	const {
		form: {
			handleSubmit,
			control,
			formState: { isValid, isSubmitting },
		},
		showSuccessToast,
		setShowSuccessToast,
		handleClose,
		onSubmit,
	} = useUpdateEmailModal(onClose, onSuccess);

	return (
		<>
			<Modal
				isOpen={isOpen}
				onClose={handleClose}
				headerContent={
					<div className="email-modal__header">
						<Text variant="heading-small" as="h2" weight="bold">
							Receba as informações de pagamento em seu e-mail
						</Text>
						<Text color="secondary">
							E fique por dentro das próximas parcelas e seja avisado dos
							vencimentos.
						</Text>
					</div>
				}
				content={
					<form className="email-modal__form" onSubmit={handleSubmit(onSubmit)}>
						<Controller
							name="email"
							control={control}
							render={({
								field: { onChange, onBlur, ...field },
								fieldState,
								formState,
							}) => (
								<EmailField
									label="E-mail"
									placeholder="exemplo@gmail.com"
									requiredInput
									error={hasFieldErrors({
										formState,
										fieldState,
										fieldName: "email",
									})}
									errorMessage={fieldState?.error?.message}
									{...field}
									onChange={onChange}
									onBlur={onBlur}
								/>
							)}
						/>

						<Button
							className="email-modal__button"
							htmlType="submit"
							expand="x"
							disabled={!isValid || isSubmitting}
							loading={isSubmitting}
						>
							Salvar
						</Button>
					</form>
				}
			/>

			{showSuccessToast && (
				<Toast
					title="Novo e-mail de contato salvo com sucesso!"
					type="success"
					onClose={() => setShowSuccessToast(false)}
				/>
			)}
		</>
	);
};
